(function () {
  'use strict';

  const DELIVERY_DAYS_AHEAD = 4;
  const COUNTDOWN_HOURS = 8;
  const DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function getDeliveryDate() {
    const d = new Date();
    d.setDate(d.getDate() + DELIVERY_DAYS_AHEAD);
    return `${DAYS[d.getDay()]}, ${d.getDate()} ${MONTHS[d.getMonth()]}`;
  }

  function formatCountdown(totalSeconds) {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${String(h).padStart(2,'0')} hrs ${String(m).padStart(2,'0')} mins ${String(s).padStart(2,'0')} secs`;
  }

  function initDeliveryDates() {
    const dateEls = document.querySelectorAll('[data-delivery-date]');
    const date = getDeliveryDate();
    dateEls.forEach(el => { el.textContent = date; });
  }

  function initCountdown() {
    const countdownEls = document.querySelectorAll('[data-countdown]');
    if (!countdownEls.length) return;
    let totalSeconds = COUNTDOWN_HOURS * 3600;
    function tick() {
      const formatted = formatCountdown(totalSeconds);
      countdownEls.forEach(el => { el.textContent = formatted; });
      if (totalSeconds > 0) totalSeconds--;
    }
    tick();
    setInterval(tick, 1000);
  }

  function initTypeSelector() {
    const typeCards = document.querySelectorAll('.abb__type-card');
    const panels = document.querySelectorAll('.abb__panel');
    typeCards.forEach(card => {
      card.addEventListener('click', function () {
        const selectedType = this.dataset.type;
        typeCards.forEach(c => c.classList.remove('abb__type-card--active'));
        this.classList.add('abb__type-card--active');
        const radio = this.querySelector('.abb__type-radio');
        if (radio) radio.checked = true;
        panels.forEach(panel => {
          if (panel.dataset.panel === selectedType) {
            panel.classList.add('abb__panel--active');
          } else {
            panel.classList.remove('abb__panel--active');
          }
        });
        syncQuantityAcrossPanels();
      });
    });
  }

  function initQuantitySelectors() {
    document.querySelectorAll('.abb-quantity__control').forEach(control => {
      const input = control.querySelector('.abb-quantity__input');
      const minus = control.querySelector('.abb-quantity__btn--minus');
      const plus = control.querySelector('.abb-quantity__btn--plus');
      if (!input) return;
      minus.addEventListener('click', function () {
        const val = parseInt(input.value, 10);
        if (val > 1) { input.value = val - 1; syncQuantityAcrossPanels(); }
      });
      plus.addEventListener('click', function () {
        const val = parseInt(input.value, 10);
        if (val < 99) { input.value = val + 1; syncQuantityAcrossPanels(); }
      });
      input.addEventListener('change', function () {
        let val = parseInt(this.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        if (val > 99) val = 99;
        this.value = val;
        syncQuantityAcrossPanels();
      });
    });
  }

  function syncQuantityAcrossPanels() {
    const activePanel = document.querySelector('.abb__panel--active');
    if (!activePanel) return;
    const activeInput = activePanel.querySelector('.abb-quantity__input');
    if (!activeInput) return;
    const qty = activeInput.value;
    document.querySelectorAll('.abb-qty-sync').forEach(hidden => { hidden.value = qty; });
  }

  function initFrequencySync() {
    const freqSelect = document.querySelector('[data-frequency-select]');
    if (!freqSelect) return;
    freqSelect.addEventListener('change', function () {
      document.querySelectorAll('.abb-freq-sync').forEach(input => { input.value = this.value; });
    });
  }

  function getSelectedVariantId() {
    // Method 1 - URL se (sabse reliable — vcard URL update karta hai)
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariant = urlParams.get('variant');
    if (urlVariant && !isNaN(urlVariant)) return urlVariant;

    // Method 2 - Main product form
    var mainForm = document.querySelector('form[action*="/cart/add"]:not([data-abb-cart-form]):not([data-abb-subscribe-form])');
    if (mainForm) {
      var mainInput = mainForm.querySelector('input[name="id"]');
      if (mainInput && mainInput.value && !isNaN(mainInput.value)) {
        return mainInput.value;
      }
    }

    // Method 3 - variant-selects component
    var variantComp = document.querySelector('variant-selects, variant-radios');
    if (variantComp) {
      var checkedRadio = variantComp.querySelector('input[type="radio"]:checked');
      if (checkedRadio && !isNaN(checkedRadio.value)) return checkedRadio.value;
      var sel = variantComp.querySelector('select');
      if (sel && !isNaN(sel.value)) return sel.value;
    }

    return null;
  }

  function updateAllAbbForms() {
    var variantId = getSelectedVariantId();
    if (!variantId) return;

    // Hidden inputs update
    var onetimeInput = document.getElementById('abb-atc-variant-id-onetime');
    if (onetimeInput) onetimeInput.value = variantId;

    var subscribeInput = document.getElementById('abb-atc-variant-id-subscribe');
    if (subscribeInput) subscribeInput.value = variantId;

    // Buy Now update
    var buyNow = document.getElementById('abb-buynow-btn');
    if (buyNow) {
      var qtyInput = document.querySelector('.abb-quantity__input');
      var qty = qtyInput ? qtyInput.value : 1;
      buyNow.setAttribute('href', '/cart/' + variantId + ':' + qty + '?checkout');
    }
  }

  function showToast(message) {
    let toast = document.getElementById('abb-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'abb-toast';
      toast.className = 'abb-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('abb-toast--visible');
    setTimeout(() => toast.classList.remove('abb-toast--visible'), 2800);
  }

  function initCartForms() {
    document.querySelectorAll('[data-abb-cart-form], [data-abb-subscribe-form]').forEach(form => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var variantId = getSelectedVariantId();
        if (variantId) {
          var hiddenInput = this.querySelector('input[name="id"]');
          if (hiddenInput) hiddenInput.value = variantId;
        }

        const formData = new FormData(this);
        const btn = this.querySelector('button[type="submit"]');
        const originalText = btn.innerHTML;

        btn.disabled = true;
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="animation:abb-spin 0.8s linear infinite"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Adding...';

        const data = {};
        formData.forEach((value, key) => {
          if (key.startsWith('properties[')) {
            if (!data.properties) data.properties = {};
            const propKey = key.replace('properties[', '').replace(']', '');
            data.properties[propKey] = value;
          } else {
            data[key] = value;
          }
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
          .then(res => {
            if (!res.ok) throw new Error('Cart error');
            return res.json();
          })
          .then(() => {
            showToast('✓ Added to cart!');
            updateCartCount();
          })
          .catch(() => {
            showToast('Something went wrong. Please try again.');
          })
          .finally(() => {
            btn.disabled = false;
            btn.innerHTML = originalText;
          });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEls = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count');
        countEls.forEach(el => { el.textContent = cart.item_count; });
      })
      .catch(() => {});
  }

  function initBuyNow() {
    document.querySelectorAll('[data-buy-now]').forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = getSelectedVariantId();
        if (!variantId) return;
        var qtyInput = document.querySelector('.abb-quantity__input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        window.location.href = '/cart/' + variantId + ':' + qty + '?checkout';
      });
    });
  }

  function injectSpinKeyframe() {
    if (document.getElementById('abb-keyframes')) return;
    const style = document.createElement('style');
    style.id = 'abb-keyframes';
    style.textContent = '@keyframes abb-spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }

function initVariantListener() {
  var updateTimer = null;

  function debouncedUpdate(variantId) {
    if (updateTimer) clearTimeout(updateTimer);
    updateTimer = setTimeout(function() {
      updateAllAbbForms(variantId);
    }, 100);
  }

  var lastUrl = location.href;
  setInterval(function() {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      debouncedUpdate(null);
    }
  }, 300);

  document.addEventListener('variant:changed', function(e) {
    var variant = e.detail && e.detail.variant;
    if (variant && variant.id) {
      debouncedUpdate(variant.id);
    } else {
      debouncedUpdate(null);
    }
  });
}

  function init() {
    injectSpinKeyframe();
    initDeliveryDates();
    initCountdown();
    initTypeSelector();
    initQuantitySelectors();
    initFrequencySync();
    initCartForms();
    initBuyNow();
    initVariantListener();
    updateAllAbbForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();